__turbopack_context__.v({
  "className": "matterfont_68ac28ae-module__KgjS9G__className",
  "variable": "matterfont_68ac28ae-module__KgjS9G__variable",
});
